/**
* 系统管理 角色数据权限
*/
<template>
    <div class="rolePower">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>数据权限</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="角色ID" v-if="isShowroleId">
                <el-input size="small" v-model="formInline.role_id" placeholder="输入角色ID"></el-input>
            </el-form-item>
            <el-form-item label="数据代码：">
                <el-input size="small" v-model="formInline.data_code" placeholder="输入数据代码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search"
                    v-auth="'roledataauth.list'">搜索</el-button>
                <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
                <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="handleEdit()"
                    v-auth="'roledataauth.addorupdate'">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="role_data_id" label="角色数据ID" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="data_code" label="数据代码">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="data_filter" label="过滤条件">
                </el-table-column>
                <el-table-column align="center" label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'roledataauth.addorupdate'">编辑
                        </el-button>
                        <el-button size="mini" type="delete" @click="handleEditDelete(scope.row)"
                            v-auth="'roledataauth.delete'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog()'>
            <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
                <el-form-item label="角色数据ID" prop="role_data_id" v-if="editForm.role_data_id">
                    <el-input size="small" v-model="editForm.role_data_id" auto-complete="off" disabled></el-input>
                </el-form-item>
                <el-form-item label="数据代码" prop="data_code">
                    <el-input size="small" v-model="editForm.data_code" auto-complete="off" placeholder="请输入数据代码">
                    </el-input>
                </el-form-item>
                <el-form-item label="过滤条件" prop="data_filter">
                    <el-input size="small" v-model="editForm.data_filter" auto-complete="off" placeholder="请输入过滤条件">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    let change = [];
    import {
        roledataauthList,
        roledataauthInfo,
        roledataauthSave,
        roledataauthDelete
    } from '../../api/userMG'
    import Pagination from '../../components/Pagination'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加',
                isShowroleId: true,
                editForm: {
                    role_id: '',
                    role_data_id: '',
                    data_code: '',
                    data_filter: '',
                },
                // rules 表单验证
                rules: {
                    role_data_id: [
                        { required: true, message: '请输入角色数据ID', trigger: 'blur' }
                    ],
                    data_code: [
                        { required: true, message: '请输入数据代码', trigger: 'blur' }
                    ],
                    data_filter: [
                        { required: true, message: '请输入过滤条件', trigger: 'blur' }
                    ]
                },
                formInline: {
                    pageindex: 1,
                    pagesize: 20,
                    role_id: '',
                    data_code: '',
                    orderby: ''
                },
                listData: [], //角色数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 10
                },
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            var formInline = localStorage.getItem('rolePower')
            if (formInline) {
                this.formInline = JSON.parse(formInline)
            }
            console.log('formInline',this.formInline)
            var introle_id = this.$route.query.role_id;
            if (introle_id) {
                this.isShowroleId = false;
                this.formInline.role_id = introle_id;
                this.editForm.role_id = introle_id
            }
            this.getdata(this.formInline)
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取角色列表
            getdata(parameter) {
                var that = this;
                that.loading = true;
                roledataauthList(parameter)
                    .then(res => {
                        that.loading = false
                        if (res.statusCode == 200) {
                            that.listData = res.data.datas
                            // 分页赋值
                            that.pageparm.currentPage = res.data.pageindex
                            that.pageparm.pageSize = res.data.pagesize
                            that.pageparm.total = res.data.rowscount
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取角色信息
            getroledataauthInfo(id) {
                var that = this;
                roledataauthInfo({ role_data_id: id }).then(res => {
                    if (res.statusCode == 200) {
                        that.editForm.role_data_id = res.data.role_data_id;
                        that.editForm.data_code = res.data.data_code;
                        that.editForm.data_filter = res.data.data_filter;
                    } else {
                        that.$message.error(res.message)
                    }
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageindex = parm.currentPage
                this.formInline.pagesize = parm.pageSize
                localStorage.setItem('rolePower', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 排序
            sortChange(column, prop, order) {
                var order = '';
                if (column.order == 'ascending') {
                    order = 'asc'
                } else if (column.order == 'descending') {
                    order = 'desc'
                }
                if (order) {
                    this.formInline.orderby = column.prop + ' ' + order
                    this.search();
                }
            },
            // 搜索事件
            search() {
                this.formInline.pageindex = 1;
                localStorage.setItem('rolePower', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 重置
            reset() {
                this.formInline.pageindex = 1;
                this.formInline.pagesize = 20;
                this.formInline.data_code = '';
                this.formInline.orderby = '';
                // 重置清掉本地搜索缓存
                localStorage.removeItem('rolePower')
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined && row != 'undefined') {
                    this.title = '修改'
                    this.getroledataauthInfo(row.role_data_id);
                } else {
                    this.title = '添加'
                    this.editForm.role_data_id = '';
                    this.editForm.data_code = '';
                    this.editForm.data_filter = '';
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                var that = this;
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        var editForm = that.editForm
                        // 添加没有role_data_id
                        if (!editForm.role_data_id) {
                            delete editForm.role_data_id
                        }
                        roledataauthSave(editForm)
                            .then(res => {
                                that.editFormVisible = false
                                if (res.statusCode == 200) {
                                    // 添加用户时清空搜索条件
                                    if (that.title == '添加') {
                                        that.reset();
                                    } else {
                                        that.getdata(that.formInline)
                                    }
                                    that.$message({
                                        type: 'success',
                                        message: that.title + '成功！'
                                    })
                                } else {
                                    that.$message.error(res.message)
                                }
                            })
                    } else {
                        return false
                    }
                })
            },
            // 删除数据权限
            handleEditDelete(row) {
                var that = this;
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        roledataauthDelete({ role_data_id: row.role_data_id })
                            .then(res => {
                                if (res.statusCode == 200) {
                                    that.$message({
                                        type: 'success',
                                        message: '删除成功！'
                                    })
                                    that.getdata(that.formInline)
                                } else {
                                    that.$message.error(res.message)
                                }
                            })
                    })
                    .catch(() => {
                        that.$message.error('已取消删除')
                    })
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>
<style>
    .rolePower .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .rolePower .page-box {
        text-align: right !important;
    }

    /* 固定el-table头部 */
    .rolePower .el-table {
        max-height: calc(100vh - 380px) !important;
    }

    .rolePower .el-table__body-wrapper.is-scrolling-none {
        overflow-y: auto !important;
        max-height: calc(100vh - 465px) !important;
    }

    .rolePower .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .rolePower .el-dialog__body::-webkit-scrollbar {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/views/system/RolePower.vue